import { BaseViewStore, ContainerProductHyperlinkCellData } from 'core/stores';
import { action, observable, makeObservable } from 'mobx';
import { ReceivingStore } from 'modules/receiving/stores';
import { formatDate } from 'core/utils';
import _ from 'lodash';

class ReceivingDetailViewStore extends BaseViewStore {
	@observable receiving = {};
	tableData = {};
	showActions = false;
	noDataItem = true;

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.receivingStore = new ReceivingStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		await this.getReceiving(this.rootStore.routerStore.routerState.params.id, {
			embed: [
				'receivingProducts',
				'receivingProducts.product',
				'receivingStatus',
				'receivingType',
				'warehouseTo',
				'warehouseFrom',
			],
		});
		this.tableData = {
			columns: [
				{
					key: 'quantity',
					title: 'RECEIVINGDETAILVIEW.TABLE.QUANTITY',
					selected: true,
					width: 200,
					filter: null,
				},
				{
					key: 'product.mainSku',
					dataCell: ContainerProductHyperlinkCellData,
					onClick: id => this.detail(id),
					title: 'RECEIVINGDETAILVIEW.TABLE.PRODUCTSKU',
					selected: true,
					width: 200,
					filter: null,
				},
			],
			actions: {},
			sortObject: [],
		};
		this.resume();
	};

	detail = id =>
		this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
			id,
		});

	@action.bound
	getReceiving = async (id, options) => {
		await this.receivingStore.getReceiving(id, options);
		this.receiving = this.receivingStore.item;
		this.receiving.estimatedReceivingDate = formatDate(this.receiving.estimatedReceivingDate, false, 'L');
		this.receiving.actualReceivingDate = formatDate(this.receiving.actualReceivingDate, true, 'L');
	};

	@action.bound
	goToEdit = () => {
		this.rootStore.routerStore.goTo('master.app.main.receiving.list.edit', {
			id: this.rootStore.routerStore.routerState.params.id,
		});
	};
}

export default ReceivingDetailViewStore;



// WEBPACK FOOTER //
// ./src/modules/receiving/stores/ReceivingDetailViewStore.js